// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"d87cfaf0","244":"05c518bf","324":"415697a5","468":"8c612d4f"}[chunkId] + ".chunk.css";
};